<template>
  <section>
    <div class="container title-area">
      <div class="columns is-centered">
        <div class="column is-8">
          <h3 class="is-size-5 has-text-weight-medium has-text-black-ter start-title intro-message"> {{ successMessage }} </h3>
          <!-- <a class="button has-text-weight-bold is-rounded start-button" @click="startSurvey" :style="{backgroundColor: $store.getters.clientStyle.secondary, borderColor: $store.getters.clientStyle.secondary}">Start de enquête</a> -->

          <!-- Success animation -->
          <svg id="successAnimation" :class="{'animated': animation}" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 70 70">
            <path id="successAnimationResult" :style="{fill: $store.getters.clientStyle.secondary}" fill="#D8D8D8" d="M35,60 C21.1928813,60 10,48.8071187 10,35 C10,21.1928813 21.1928813,10 35,10 C48.8071187,10 60,21.1928813 60,35 C60,48.8071187 48.8071187,60 35,60 Z M23.6332378,33.2260427 L22.3667622,34.7739573 L34.1433655,44.40936 L47.776114,27.6305926 L46.223886,26.3694074 L33.8566345,41.59064 L23.6332378,33.2260427 Z"/>
            <circle id="successAnimationCircle" :style="{stroke: $store.getters.clientStyle.secondary}" cx="35" cy="35" r="24" stroke="#979797" stroke-width="2" stroke-linecap="round" fill="transparent"/>
            <polyline id="successAnimationCheck" :style="{stroke: $store.getters.clientStyle.secondary}" stroke="#979797" stroke-width="2" points="23 34 34 43 47 27" fill="transparent"/>
          </svg>

          <!-- <button id="replay" @click="reanimate">Replay</button> -->

        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      animation: true,
      message: this.$store.getters.getInfo.after_send_message
      // animation: document.getElementById('successAnimation'),
      // restart: document.getElementById('replay')
    }
  },
  mounted () {
    localStorage.clear()
  },
  methods: {
    reanimate () {
      this.animation = false
      setTimeout(() => {
        this.animation = true
      }, 1000)
    }
  },
  computed: {
    successMessage () {
      return  this.message !== null ? this.message : ''
    }
  }
}
</script>

<style type="scss" scoped>

  .title-area {
    margin-top: 42px;
    margin-bottom: 60px;
    text-align: center;
  }

  .start-title {
    padding-bottom: 42px;
    /* color: #111f39; */
  }

  /* html,
  body {
    height: 100%;
  }

  body {
    align-items: center;
    background-color: #35297B;
    display: flex;
    justify-content: center;
  } */

  @-webkit-keyframes scaleAnimation {
    0% {
      opacity: 0;
      -webkit-transform: scale(1.5);
              transform: scale(1.5);
    }
    100% {
      opacity: 1;
      -webkit-transform: scale(1);
              transform: scale(1);
    }
  }

  @keyframes scaleAnimation {
    0% {
      opacity: 0;
      -webkit-transform: scale(1.5);
              transform: scale(1.5);
    }
    100% {
      opacity: 1;
      -webkit-transform: scale(1);
              transform: scale(1);
    }
  }
  @-webkit-keyframes drawCircle {
    0% {
      stroke-dashoffset: 151px;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes drawCircle {
    0% {
      stroke-dashoffset: 151px;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @-webkit-keyframes drawCheck {
    0% {
      stroke-dashoffset: 36px;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes drawCheck {
    0% {
      stroke-dashoffset: 36px;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @-webkit-keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  #successAnimationCircle {
    stroke-dasharray: 151px 151px;
    stroke: #d4d4d4;
  }

  #successAnimationCheck {
    stroke-dasharray: 36px 36px;
    stroke: #d4d4d4;
  }

  #successAnimationResult {
    fill: #d4d4d4;
    opacity: 0;
  }

  #successAnimation.animated {
    -webkit-animation: 1s ease-out 0s 1 both scaleAnimation;
            animation: 1s ease-out 0s 1 both scaleAnimation;
  }
  #successAnimation.animated #successAnimationCircle {
    -webkit-animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCircle, 0.3s linear 0.9s 1 both fadeOut;
            animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCircle, 0.3s linear 0.9s 1 both fadeOut;
  }
  #successAnimation.animated #successAnimationCheck {
    -webkit-animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCheck, 0.3s linear 0.9s 1 both fadeOut;
            animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCheck, 0.3s linear 0.9s 1 both fadeOut;
  }
  #successAnimation.animated #successAnimationResult {
    -webkit-animation: 0.3s linear 0.9s both fadeIn;
            animation: 0.3s linear 0.9s both fadeIn;
  }

  #replay {
    background: rgba(255, 255, 255, 0.2);
    border: 0;
    border-radius: 3px;
    bottom: 100px;
    color: #FFF;
    left: 50%;
    outline: 0;
    padding: 10px 30px;
    position: absolute;
    -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
  }
  #replay:active {
    background: rgba(255, 255, 255, 0.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/SendSuccess.vue